import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const fadeUp = { hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0 } };
const stagger = { show: { transition: { staggerChildren: 0.12 } } };

const HowItWorks = ({ onOpenAssessment }) => {
  const steps = [
    { n: "1", t: "Quick Online Test", d: "Your child completes a short, level-appropriate maths diagnostic." },
    { n: "2", t: "Strengths & Gaps", d: "We analyze topics mastered and areas needing support." },
    { n: "3", t: "Parent Report", d: "You receive a clear, friendly report with recommendations." },
    { n: "4", t: "Personalized Path", d: "We advise the best class—remedial, bridge, or advancement." },
  ];

  return (
    <section id="how" className="py-20">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }} variants={stagger}>
          <motion.h2 variants={fadeUp} className="text-3xl md:text-4xl font-extrabold text-indigo-900">
            How the Free Assessment Works
          </motion.h2>
          <motion.p variants={fadeUp} className="mt-2 text-gray-600 max-w-3xl">
            A simple process designed for clarity and impact.
          </motion.p>

          <div className="mt-10 grid md:grid-cols-4 gap-6">
            {steps.map((s) => (
              <motion.div key={s.n} variants={fadeUp} className="p-6 rounded-2xl border bg-white hover:shadow-lg transition">
                <div className="w-10 h-10 rounded-full bg-yellow-400 flex items-center justify-center font-bold">{s.n}</div>
                <h3 className="mt-4 font-semibold text-indigo-900">{s.t}</h3>
                <p className="text-gray-600 text-sm mt-1">{s.d}</p>
              </motion.div>
            ))}
          </div>

          <div className="mt-10 grid md:grid-cols-2 gap-8 items-center">
            <motion.div variants={fadeUp} className="rounded-2xl overflow-hidden border">
              <img src="/tm1.png" alt="Sample parent report" className="w-full h-auto" />
            </motion.div>
            <motion.blockquote variants={fadeUp} className="bg-indigo-50 p-6 rounded-2xl border border-indigo-100">
              <p className="text-indigo-900 font-semibold">
                “We discovered exactly where our son was struggling and how to help him. Two months later, his confidence is back!”
              </p>
              <footer className="mt-2 text-sm text-gray-600">— Amina, Parent of Primary 5</footer>
<Link to="/register-student">
              <button
                
                className="mt-4 px-5 py-3 bg-yellow-400 text-black font-semibold rounded-lg hover:bg-yellow-300"
              >
                Take the Free Maths Assessment
              </button>
              </Link>
             
            </motion.blockquote>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
